export default "__VITE_ASSET__BEpkJ4t4__"